import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { useIsRestoring } from '@tanstack/react-query';
import Dashboard from './components/Dashboard';
import GalleryLayout from './components/GalleryLayout';
import GuestHome from './components/GuestHome';
import GallerySlideshow from './components/GallerySlideshow';
import RootLanding from './components/RootLanding';
import { LegacyDashboardRedirect } from './components/LegacyRedirects';
import RequireGuestAuth from './components/RequireGuestAuth';
import LoadingSpinner from './components/LoadingSpinner';
import ServiceWorkerUpdateNotice from './components/ServiceWorkerUpdateNotice';
import { UploadQueueProvider } from './hooks/useUploadQueue';

function App() {
  const isRestoring = useIsRestoring();

  if (isRestoring) {
    return (
      <LoadingSpinner logo="/placeholder-logo.svg" />
    );
  }

  return (
    <UploadQueueProvider>
      <ServiceWorkerUpdateNotice />
      <Router future={{ v7_relativeSplatPath: true, v7_startTransition: true }}>
        <Routes>
          <Route path="/" element={<RootLanding />} />
          <Route path="/dashboard/*" element={<LegacyDashboardRedirect />} />
          <Route path="/g/:galleryId" element={<GalleryLayout />}>
            <Route index element={<GuestHome />} />
            <Route path="slideshow" element={<GallerySlideshow />} />
            <Route
              path="dashboard/*"
              element={
                <RequireGuestAuth>
                  <Dashboard />
                </RequireGuestAuth>
              }
            />
          </Route>
          <Route path="*" element={<RootLanding />} />
        </Routes>
      </Router>
    </UploadQueueProvider>
  );
}

export default App;
